import {BulkArchiveItemsResponse, ArchiveRecord, BulkUnarchiveItemsResponse} from 'archive/ArchiveConstants';
import {StarsResponse} from 'stars/StarsConstants';
import * as net from 'util/Net';

export type BulkArchiveResponse = BulkArchiveItemsResponse & {
  archiveRecordsByItemId: {[itemId: string]: ArchiveRecord};
};

export function bulkArchive(ids: Array<string>, purpose: string): JQueryPromise<BulkArchiveResponse> {
  return net.postJSON({
    url: '/1/api/storable-schemas:bulk-archive',
    data: {ids, purpose},
  });
}

export function bulkUnarchive(ids: Array<string>): JQueryPromise<BulkUnarchiveItemsResponse> {
  return net.postJSON({
    url: '/1/api/storable-schemas:bulk-unarchive',
    data: {ids},
  });
}

export function star(ids: Array<string>): JQueryPromise<StarsResponse> {
  return net.postJSON({
    url: '/1/api/storable-schemas:star',
    data: {storableSchemaIds: ids},
  });
}

export function unstar(ids: Array<string>): JQueryPromise<StarsResponse> {
  return net.postJSON({
    url: '/1/api/storable-schemas:unstar',
    data: {storableSchemaIds: ids},
  });
}

export function fetchStarred(): JQueryPromise<StarsResponse> {
  return net.getJSON('/1/api/storable-schemas/starred');
}
